'use client'

// src/util/htmlSectionInjection.ts
var HEAD_ALLOWLIST = 'style, link[rel="stylesheet"]';
var parseSectionDocument = (html) => {
  if (typeof DOMParser === "undefined") return null;
  return new DOMParser().parseFromString(html, "text/html");
};
var parseHtmlSectionParts = (html) => {
  const doc = parseSectionDocument(html);
  if (!doc) {
    return { headExtras: "", bodyHtml: html };
  }
  const headExtras = Array.from(doc.head.querySelectorAll(HEAD_ALLOWLIST)).map((element) => element.outerHTML).join("");
  return { headExtras, bodyHtml: doc.body.innerHTML };
};
var assertStudioIsolation = (container) => {
  const view = container.ownerDocument.defaultView;
  if (!view) return;
  if (view.top === view) {
    throw new Error("studio-isolated HTML injection cannot target the top-level document");
  }
};
var recreateScripts = (container, onScriptError) => {
  const ownerDocument = container.ownerDocument;
  const inertScripts = Array.from(container.querySelectorAll("script"));
  for (const inert of inertScripts) {
    try {
      const script = ownerDocument.createElement("script");
      for (const { name, value } of Array.from(inert.attributes)) {
        script.setAttribute(name, value);
      }
      script.text = inert.text;
      inert.replaceWith(script);
    } catch (error) {
      onScriptError == null ? void 0 : onScriptError(error);
    }
  }
};
var injectHtmlSection = (container, html, options) => {
  if (options.mode === "studio-isolated") {
    assertStudioIsolation(container);
  }
  const doc = parseSectionDocument(html);
  if (!doc) {
    return () => {
      container.replaceChildren();
    };
  }
  const ownerDocument = container.ownerDocument;
  const nodes = [
    ...Array.from(doc.head.querySelectorAll(HEAD_ALLOWLIST)),
    ...Array.from(doc.body.childNodes)
  ].map((node) => ownerDocument.importNode(node, true));
  container.replaceChildren(...nodes);
  if (options.executeScripts) {
    recreateScripts(container, options.onScriptError);
  }
  return () => {
    container.replaceChildren();
  };
};

export {
  parseHtmlSectionParts,
  injectHtmlSection
};
//# sourceMappingURL=chunk-4FXSFWXZ.mjs.map